import type { TranslationDictionary } from '../types';

export const ur: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
    delete: 'حذف کریں',
    edit: 'ترمیم کریں',
    create: 'نیا بنائیں',
    back: 'واپس',
    search: 'تلاش کریں...',
    filter: 'فلٹر',
    refresh: 'تازہ کریں',
    submit: 'جمع کریں',
    loading: 'لوڈ ہو رہا ہے...',
    close: 'بند کریں',
    yes: 'ہاں',
    no: 'نہیں',
    active: 'فعال',
    inactive: 'غیر فعال',
    open: 'کھلا',
    pending: 'زیر التواء',
    approved: 'منظور شدہ',
    rejected: 'مسترد شدہ',
    completed: 'مکمل',
    inProgress: 'جاری ہے',
    resolved: 'حل شدہ',
    viewDetails: 'تفصیلات دیکھیں',
    download: 'ڈاؤن لوڈ کریں',
    print: 'پرنٹ کریں',
    export: 'برآمد کریں',
    actions: 'اقدامات',
    status: 'حیثیت',
    date: 'تاریخ',
    total: 'کل',
    all: 'تمام',
    reset: 'ری سیٹ کریں',
    more: 'مزید',
    select: 'منتخب کریں',
    language: 'زبان',
    selectLanguage: 'زبان منتخب کریں',
    saveChanges: 'تبدیلیاں محفوظ کریں',
    savedSuccessfully: 'کامیابی سے محفوظ ہو گیا',
    confirm: 'تصدیق کریں',
    home: 'ہوم',
    favorites: 'پسندیدہ',
    pinned: 'پن شدہ',
    tenant: 'سوسائٹی / کمیونٹی',
    openMenu: 'مینو کھولیں',
    expandMenu: 'مینو کو پھیلائیں',
    minimizeMenu: 'مینو کو سکیڑیں',
    lightMode: 'لائٹ موڈ',
    darkMode: 'ڈارک موڈ',
    accountMenu: 'اکاؤنٹ مینو',
    commandPalette: 'کمانڈ پیلیٹ',
    searchPages: 'صفحات تلاش کریں...',
    favorite: 'پسندیدہ',
    pin: 'پن کریں',
    calendar: 'کیلنڈر',
    inbox: 'ان باکس',
    ledger: 'کھاتہ بہی',
    viewAll: 'تمام دیکھیں',
    platformNoSociety: 'پلیٹ فارم (کوئی سوسائٹی نہیں)',
    noSociety: 'کوئی سوسائٹی نہیں',
    trial: 'ٹرائل',
    expired: 'مدت ختم',
    suspended: 'معطل',
    emptyTitle: 'یہاں ابھی کچھ نہیں ہے',
    emptyDescription: 'تفصیلات اور اپڈیٹس دستیاب ہونے پر یہاں ظاہر ہوں گی۔',
    tryAgain: 'دوبارہ کوشش کریں',
    somethingWentWrong: 'کچھ غلط ہو گیا',
    goBack: 'واپس جائیں',
    goToHome: 'ہوم پر جائیں',
    referenceId: 'حوالہ شناختی نمبر',
    or: 'یا',
  },
  auth: {
    login: 'سائن ان کریں',
    logout: 'لاگ آؤٹ',
    profile: 'پروفائل',
    email: 'ای میل پتہ',
    password: 'پاس ورڈ',
    forgotPassword: 'پاس ورڈ بھول گئے؟',
    sendOtp: 'او ٹی پی بھیجیں',
    verifyOtp: 'او ٹی پی کی تصدیق کریں',
    mobile: 'موبائل نمبر',
    rememberMe: 'مجھے یاد رکھیں',
    biometricLogin: 'بائیو میٹرک لاگ ان',
    changePassword: 'پاس ورڈ تبدیل کریں',
    signOut: 'سائن آؤٹ',
    welcome: 'خوش آمدید',
    signIn: 'سائن ان کریں',
    signInSubtitle: 'اپنے سوسائٹی ورک اسپیس میں محفوظ طریقے سے داخل ہوں۔',
    signingInTo: '{{name}} میں سائن ان کر رہے ہیں',
    method: 'طریقہ کار',
    emailTab: 'ای میل',
    mobileTab: 'موبائل',
    otpTab: 'او ٹی پی',
    emailLabel: 'ای میل پتہ',
    mobileLabel: 'موبائل نمبر',
    passwordLabel: 'پاس ورڈ',
    enableBiometricAfterLogin: 'سائن ان کے بعد بائیو میٹرک لاگ ان فعال کریں',
    signInWithBiometrics: 'بائیو میٹرکس سے سائن ان کریں',
    verifyAndSignIn: 'تصدیق کریں اور سائن ان کریں',
    changeIdentifier: 'شناخت تبدیل کریں',
    enterOtpSentTo: 'اپنے {{channel}} پر بھیجا گیا او ٹی پی درج کریں۔',
    otpCodeLabel: 'او ٹی پی کوڈ',
    channelLabel: 'چینل',
    emailChannel: 'ای میل',
    smsChannel: 'ایس ایم ایس',
    forgotPasswordTitle: 'پاس ورڈ بھول گئے',
    forgotPasswordSubtitle: 'اپنا ای میل یا موبائل درج کریں۔ ہم پاس ورڈ ری سیٹ کے لیے او ٹی پی بھیجیں گے۔',
    emailOrMobile: 'ای میل یا موبائل نمبر',
    backToSignIn: 'سائن ان پر واپس جائیں',
    resetPasswordTitle: 'پاس ورڈ ری سیٹ کریں',
    resetPasswordSubtitle: 'اپنے ای میل یا موبائل پر بھیجا گیا او ٹی پی درج کریں، پھر نیا پاس ورڈ منتخب کریں۔',
    newPasswordLabel: 'نیا پاس ورڈ',
    confirmPasswordLabel: 'پاس ورڈ کی تصدیق کریں',
    updatePassword: 'پاس ورڈ اپ ڈیٹ کریں',
    changePasswordTitle: 'پاس ورڈ تبدیل کریں',
    changePasswordSubtitle: 'اپنا اکاؤنٹ پاس ورڈ اپ ڈیٹ کریں۔ آپ سائن ان رہیں گے۔',
    currentPasswordLabel: 'موجودہ پاس ورڈ',
    confirmNewPasswordLabel: 'نئے پاس ورڈ کی تصدیق کریں',
    savePassword: 'پاس ورڈ محفوظ کریں',
    passwordRequirementNotice: 'کم از کم 8 حروف پر مشتمل ہو جس میں بڑے حروف، چھوٹے حروف، عدد اور خصوصی علامت شامل ہو۔',
    bannerTagline: 'انٹرپرائز سوسائٹی آپریشنز — بینکنگ، وصولیاں، میٹنگز اور رہائشی ایک ہی جگہ۔',
    bannerSubtext: 'کالونیوں اور ہاؤسنگ سوسائٹیوں کے لیے محفوظ ملٹی ٹیننٹ پلیٹ فارم۔',
    biometricMobileOnly: 'بائیو میٹرک لاگ ان صرف موبائل ایپ پر دستیاب ہے۔',
    biometricDesktopInfo: 'بائیو میٹرک لاگ ان ApnaBlock موبائل ایپ میں دستیاب ہے۔',
    signedInBiometrics: 'بائیو میٹرکس کے ذریعے کامیابی سے سائن ان ہو گیا',
    biometricSessionExpired: 'سیشن ختم یا منسوخ ہو گیا۔ براہ کرم اپنے پاس ورڈ کے ساتھ سائن ان کریں۔',
    biometricAuthFailed: 'بائیو میٹرک تصدیق ناکام ہو گئی۔ براہ کرم پاس ورڈ استعمال کریں۔',
    biometricEnrollSuccess: 'بائیو میٹرک لاگ ان فعال ہو گیا',
    biometricEnrollCancelled: 'بائیو میٹرک رجسٹریشن منسوخ ہو گئی۔ عام لاگ ان کامیاب رہا۔',
    welcomeMarketing: 'مارکیٹنگ پارٹنر پورٹل میں خوش آمدید',
    welcomePlatform: 'پلیٹ فارم ایڈمنسٹریشن میں خوش آمدید',
    welcomeBackToast: 'خوش آمدید',
    otpSentSuccess: 'او ٹی پی کامیابی کے ساتھ بھیج دیا گیا',
    otpVerifyFailed: 'او ٹی پی کی تصدیق ناکام ہو گئی',
    loginFailed: 'لاگ ان ناکام ہو گیا',
    biometricAuthReason: 'ApnaBlock میں سائن ان کرنے کے لیے اپنی شناخت کی تصدیق کریں',
    biometricAvailableFor: '{{identifier}} کے لیے بائیو میٹرک لاگ ان دستیاب ہے',
    biometricEnrollPrompt: 'کیا {{name}} کے لیے بائیو میٹرک لاگ ان فعال کریں؟',
  },
  nav: {
    dashboard: 'ڈیش بورڈ',
    society: 'سوسائٹی',
    societySettings: 'میری سوسائٹی',
    societyBlocks: 'بلاکس / ٹاورز',
    societyHouses: 'مکانات / فلیٹس',
    societyResidents: 'رہائشی',
    societyStaff: 'عملہ',
    imports: 'ڈیٹا امپورٹ',
    finance: 'مالیات اور اکاؤنٹس',
    financePayments: 'میری ادائیگیاں',
    financeCollections: 'وصولیاں',
    financeSocietyFund: 'سوسائٹی فنڈ',
    financeSpecialCollections: 'خصوصی وصولیاں',
    financeCorpusFund: 'کارپس فنڈ',
    financeExpenses: 'اخراجات',
    financeExpenseGroups: 'اخراجات کے گروپس',
    financeWaterTanker: 'پانی کا ٹینکر',
    financeReimbursements: 'معاوضے کا دعویٰ',
    financeBanking: 'بینک اکاؤنٹس',
    financeStatements: 'اسٹیٹمنٹس اور رسیدیں',
    financeReports: 'مالی رپورٹس',
    financeReconciliation: 'ادائیگی کی مصالحت',
    security: 'سیکیورٹی اور گیٹ',
    gatePasses: 'گیٹ پاس',
    securityDashboard: 'سیکیورٹی ڈیش بورڈ',
    securityGates: 'گیٹ کا انتظام',
    securityShifts: 'چوکیدار کی شفٹ رپورٹس',
    securityPolicies: 'سیکیورٹی پالیسیاں',
    securityDeskPortal: 'سیکیورٹی گیٹ ڈیسک',
    visitors: 'زائرین ڈیسک',
    securityCameras: 'سی سی ٹی وی کیمرے',
    community: 'کمیونٹی اور مواصلات',
    notices: 'نوٹس بورڈ',
    communityForum: 'کمیونٹی فورم',
    events: 'تقریبات',
    eventsList: 'تقریبات',
    eventsCalendar: 'تقریبات کا کیلنڈر',
    invitations: 'دعوت نامے اور جوابات',
    whatsapp: 'واٹس ایپ لاگز',
    notifications: 'اطلاعات',
    operations: 'آپریشنز اور ہیلپ ڈیسک',
    complaints: 'شکایات',
    serviceRequests: 'سروس کی درخواستیں',
    serviceDirectory: 'سروس ڈائرکٹری',
    amenities: 'سہولیات',
    meetings: 'اجلاس / میٹنگز',
    documents: 'دستاویزات کا والٹ',
    governance: 'انتظامیہ اور انتخابات',
    polls: 'رہائشیوں کی رائے شماری',
    elections: 'انتخابات',
    governancePetitions: 'درخواست دائر کریں',
    governanceResignation: 'استعفیٰ پیش کریں',
    administration: 'انتظامیہ',
    adminLicense: 'لائسنس',
    adminInvoices: 'سبسکرپشن بلز',
    adminRoles: 'کردار اور اجازتیں',
    adminLetterhead: 'لیٹر ہیڈ اور برانڈنگ',
    adminIntegrations: 'ایس ایم ایس اور واٹس ایپ',
    adminAiConfig: 'اے آئی کنفیگریشن',
    adminNavigation: 'مینو کی تخصیص',
    adminAudit: 'آڈٹ لاگز',
    documentationGroup: 'مدد اور دستاویزات',
    societySupportDesk: 'مدد اور معاونت',
    docsKnowledgeBase: 'علم کا مرکز',
    docsRoleMatrix: 'کردار اور اجازت کا میٹرکس',
    docsQaHub: 'کیو اے ٹیسٹ ہب',
    docsTestExplorer: 'ٹیسٹ کیس ایکسپلورر',
    licenseLocked: 'لائسنس',
    platformSocietiesGroup: 'سوسائٹیز اور کرایہ دار',
    platformSocieties: 'تمام سوسائٹیاں',
    platformSocietiesNew: 'سوسائٹی رجسٹر کریں',
    platformSocietyTypes: 'سوسائٹی کی اقسام اور درجہ بندی',
    platformTrials: 'مفت آزمائش',
    platformSubscriptions: 'سبسکرپشنز',
    platformLicenses: 'سافٹ ویئر لائسنس',
    platformPlans: 'سبسکرپشن پلانز',
    platformInvoices: 'بلنگ اور انوائسز',
    platformPricingOverrides: 'قیمتوں میں تبدیلیاں',
    platformCoupons: 'کوپنز اور رعایتیں',
    platformPromotionGroup: 'ترقی اور تشہیر',
    platformPromotionDashboard: 'گروتھ ڈیش بورڈ',
    platformPromotionProspects: 'ممکنہ گاہک',
    platformPromotionCampaigns: 'مہمات',
    platformPromotionTemplates: 'پیغامات کے ٹیمپلیٹس',
    platformPromotionSenderProfiles: 'بھیجنے والے کے پروفائلز',
    platformPromotionEmail: 'ای میل مارکیٹنگ',
    platformPromotionWhatsapp: 'واٹس ایپ براڈکاسٹس',
    platformPromotionSms: 'ایس ایم ایس مارکیٹنگ',
    platformPromotionOther: 'دیگر چینلز',
    platformReferrals: 'ملحقہ اور ریفرلز',
    platformMarketing: 'مارکیٹنگ کا عملہ',
    platformPromotionAnalytics: 'تشہیر کے تجزیات',
    platformPromotionSettings: 'مارکیٹنگ کی ترتیبات',
    platformManagementGroup: 'پلیٹ فارم اور معاونت',
    platformWebsite: 'ویب سائٹ سی ایم ایس اور برانڈنگ',
    platformSupportTickets: 'سپورٹ ٹکٹ ڈیسک',
    platformFeatureRequests: 'فیچر کی درخواستیں',
    platformFeatures: 'فیچر فلیگز',
    platformUsers: 'پلیٹ فارم ایڈمنسٹریٹرز',
    platformCoverageAudit: 'دستاویزات کی کوریج کا آڈٹ',
    platformReportsGroup: 'تجزیات اور رپورٹس',
    platformAnalytics: 'پلیٹ فارم کے تجزیات',
    platformSystemGroup: 'سسٹم اور سیکیورٹی',
    platformSystemHealth: 'سسٹم کی صحت',
    platformAuditLogs: 'آڈٹ لاگز',
    platformNotifications: 'الرٹس اور اطلاعات',
    platformSettings: 'عالمی ترتیبات',
    platformDataCleanup: 'ڈیٹا کی صفائی',
    platformGoogleCalendar: 'گوگل کیلنڈر کا انضمام',
    platformMaintenance: 'ڈیٹا بیس کی دیکھ بھال',
    directory: 'رہائشیوں کی ڈائرکٹری',
    members: 'اراکین',
    houses: 'یونٹس اور فلیٹس',
    settings: 'ترتیبات',
    myUnit: 'میرا یونٹ',
    waterTankers: 'پانی کا ٹینکر',
    patrol: 'گارڈ گشت',
    cameras: 'لائیو سی سی ٹی وی',
    marketplace: 'مارکیٹ پلیس',
    profile: 'میرا پروفائل',
    superAdmin: 'پلیٹ فارم ایڈمن',
    staff: 'سوسائٹی عملہ',
    helpDesk: 'ہیلپ ڈیسک',
    favorites: 'پسندیدہ',
    pinned: 'پن شدہ',
    navGroupHome: 'ہوم',
    navGroupSociety: 'میری سوسائٹی',
    navGroupMoney: 'رقم اور واجبات',
    navGroupSecurity: 'سیکیورٹی اور گیٹ',
    navGroupCommunity: 'کمیونٹی',
    navGroupManagement: 'انتظامیہ',
    navGroupAdmin: 'ایڈمن',
    navGroupHelp: 'مدد اور دستاویزات',
    securityNotificationSettings: 'سیکیورٹی پالیسیاں',
    securityCcCameras: 'سی سی ٹی وی کیمرے',
  },
  mobile: {
    greetingMorning: 'صبح بخیر، {{name}}',
    greetingAfternoon: 'دوپہر بخیر، {{name}}',
    greetingEvening: 'شام بخیر، {{name}}',
    greetingNight: 'شب بخیر، {{name}}',
    greetingGeneric: 'خوش آمدید، {{name}}',
    priorityAttention: 'توجہ طلب',
    priorityAllClear: 'تمام واجبات ادا شدہ ہیں',
    priorityAllClearSub: 'کوئی زیر التواء مینٹیننس یا بل نہیں ہے',
    payMaintenance: 'مینٹیننس ادا کریں',
    payDues: 'ابھی ادا کریں',
    viewDues: 'واجبات دیکھیں',
    viewReceipt: 'رسید دیکھیں',
    dueBy: 'آخری تاریخ {{date}}',
    quickActions: 'فوری اقدامات',
    actionPay: 'واجبات کی ادائیگی',
    actionVisitors: 'مہمان',
    actionRaiseIssue: 'مسئلہ درج کریں',
    actionNotices: 'نوٹس بورڈ',
    actionBookFacility: 'سہولت بک کریں',
    actionEmergency: 'ہنگامی SOS',
    actionDirectory: 'ڈائریکٹری',
    actionPolls: 'ووٹنگ اور پولز',
    actionMeetings: 'میٹنگز',
    societyUpdates: 'سوسائٹی اپڈیٹس',
    gateAndVisitors: 'گیٹ اور مہمان',
    upcomingEvents: 'آنے والی تقریبات',
    maintenanceAndReceipts: 'مینٹیننس اور رسیدیں',
    pendingApprovals: 'زیر التواء منظوری',
    collectionsOverview: 'وصولیوں کا جائزہ',
    pendingReview: 'زیر التواء جائزہ',
    noPendingReviews: 'تمام جائزے مکمل ہیں',
    totalCollected: 'کل وصول شدہ رقم',
    totalOutstanding: 'کل واجب الادا رقم',
    activeGatePasses: 'فعال گیٹ پاسز',
    noVisitorsToday: 'آج کوئی مہمان نہیں آیا',
    noActivePasses: 'کوئی فعال پاس نہیں ہے',
    preApproveGuest: 'مہمان کی پیشگی منظوری',
    recentReceipts: 'حالیہ رسیدیں',
    noRecentReceipts: 'کوئی حالیہ لین دین نہیں',
    managementDesk: 'کمیٹی ڈیسک',
    switchRole: 'منظر بدلیں',
    residentView: 'رہائشی منظر',
    committeeView: 'کمیٹی منظر',
    emergencyModalTitle: 'ہنگامی SOS الرٹ',
    emergencyModalSubtitle: 'سیکیورٹی گارڈ اور سوسائٹی کمیٹی کو فوری ہنگامی پیغام بھیجیں',
    tapToCall: 'گارڈ کو کال کریں',
    tapToWhatsApp: 'دفتر واٹس ایپ',
    pullToRefresh: 'ریفریش کرنے کے لیے نیچے کھینچیں',
    refreshing: 'ریفریش ہو رہا ہے…',
    noMeetingsScheduled: 'کوئی میٹنگ طے نہیں ہے',
    noNoticesPublished: 'کوئی اعلان شائع نہیں ہوا',
    noUpcomingEvents: 'کوئی آنے والی تقریب نہیں ہے',
    viewAllNotices: 'تمام نوٹس دیکھیں',
    viewAllEvents: 'تمام تقریبات دیکھیں',
    viewAllComplaints: 'تمام شکایات دیکھیں',
    sectionDiscover: 'دریافت کریں',
    sectionEngage: 'شرکت کریں',
    sectionPay: 'ادائیگی',
    cardResidents: 'رہائشی',
    cardResidentsDesc: 'اپنی سوسائٹی کے لوگوں کو تلاش کریں',
    cardLocalHelp: 'مقامی مدد',
    cardLocalHelpDesc: 'روزمرہ گھریلو مدد تلاش کریں',
    cardEmergencyContacts: 'ہنگامی رابطے',
    cardEmergencyContactsDesc: 'پولیس، ایمبولینس اور ضروری نمبرز',
    cardHelpDesk: 'مدد اور شکایات',
    cardHelpDeskDesc: 'مسئلہ درج کریں یا مدد طلب کریں',
    cardFacilities: 'سہولیات',
    cardFacilitiesDesc: 'سوسائٹی کی سہولیات بک کریں',
    cardNotices: 'سوسائٹی نوٹس',
    cardNoticesDesc: 'سوسائٹی کی جانب سے اہم اعلانات',
    cardCommunity: 'کمیونٹی',
    cardCommunityDesc: 'پول، اجلاس اور تقریبات',
    cardDocuments: 'دستاویزات',
    cardDocumentsDesc: 'سوسائٹی اور ذاتی دستاویزات',
    cardPaymentsDues: 'ادائیگی اور بقایا جات',
    cardPaymentsDuesDesc: 'بقایا جات دیکھیں اور ادائیگی کریں',
    cardUtilities: 'یوٹیلیٹیز',
    cardUtilitiesDesc: 'بجلی، پانی اور دیگر ضروریات',
    actionRequired: 'کارروائی درکار ہے',
    pendingActionSubtitle: '{{count}} امور کمیٹی جائزے کے منتظر ہیں',
    collectionsStatus: 'وصولیاں اور بقایا جات',
    uncollectedSocietyDues: '{{count}} زیر التواء ادائیگیاں',
    collectedThisMonth: 'اس ماہ وصول شدہ رقم',
    viewLedger: 'لیجر دیکھیں',
    committeeActions: 'کمیٹی کے اقدامات',
    postNotice: 'نوٹس جاری کریں',
    postNoticeDesc: 'سوسائٹی کو باضابطہ نوٹس بھیجیں',
    addExpense: 'خرچ درج کریں',
    addExpenseDesc: 'سوسائٹی کے اخراجات کا اندراج کریں',
    scheduleMeeting: 'میٹنگ طے کریں',
    scheduleMeetingDesc: 'کمیٹی میٹنگ کا انعقاد کریں',
    residentDirectory: 'رہائشیوں کی ڈائرکٹری',
    residentDirectoryDesc: 'رہائشیوں کو تلاش کریں اور رابطہ کریں',
    complaintsOverview: 'شکایات اور ہیلپ ڈیسک',
    upcomingMeetingsCount: '{{count}} آنے والے اجلاس',
    viewMeetingAgenda: 'میٹنگ کی تفصیلات اور ایجنڈا دیکھیں',
    resignOfficeTitle: 'استعفیٰ پیش کریں',
    resignOfficeNotice: 'سوسائٹی کے ارکان کو باضابطہ استعفیٰ پیش کریں',
    activeSocietyElections: 'فعال سوسائٹی انتخابات',
    votingLiveStatus: 'اراکین کے لیے ووٹنگ جاری ہے',
    castYourVotePrompt: 'نامزد کمیٹی امیدواروں کے لیے اپنا ووٹ ڈالیں',
    recentNotices: 'حالیہ نوٹس',
    myComplaints: 'میری شکایات',
    noActiveComplaints: 'کوئی فعال شکایت یا ٹکٹ نہیں ہے',
  },
  profile: {
    profileTitle: 'پروفائل اور ترجیحات',
    profileSubtitle: 'اپنی ذاتی تفصیلات، سیکیورٹی سیٹنگز اور ایپ کی زبان کا انتظام کریں۔',
    basicDetails: 'بنیادی تفصیلات',
    firstName: 'پہلا نام',
    lastName: 'آخری نام',
    email: 'ای میل',
    mobile: 'موبائل نمبر',
    saveDetails: 'تفصیلات محفوظ کریں',
    userId: 'صارف کی شناخت',
    roles: 'تفویض کردہ کردار',
    tenant: 'سوسائٹی / کمیونٹی',
    securityBiometrics: 'سیکیورٹی اور بائیو میٹرکس',
    securityBiometricsDesc: 'فنگر پرنٹ یا چہرے کی شناخت کے ساتھ آسانی سے ایپ کھولیں۔',
    biometricLoginEnabled: 'بائیو میٹرک لاگ ان فعال ہے',
    enableBiometricLogin: 'بائیو میٹرک لاگ ان کو فعال کریں',
    notificationPreferences: 'اطلاعات کی ترجیحات',
    notificationPreferencesDesc: 'کنٹرول کریں کہ آپ کو نوٹس اور الرٹس کیسے موصول ہوں۔',
    languagePreferences: 'ایپ کی زبان',
    languagePreferencesDesc: 'اپنی پسندیدہ زبان منتخب کریں۔ ایپ ہمیشہ اسی زبان میں کھلے گی۔',
    currentLanguage: 'موجودہ زبان',
    selectDefaultLanguage: 'پہلے سے طے شدہ زبان منتخب کریں',
    defaultLanguageNotice: 'آپ کی پسندیدہ زبان محفوظ ہے اور ہر بار ایپ کھولنے پر لاگو ہوگی۔',
    saveLanguage: 'پہلے سے طے شدہ زبان کے طور پر سیٹ کریں',
    languageUpdated: 'زبان کی ترجیح کامیابی سے محفوظ ہو گئی',
  },
  dashboard: {
    welcomeBack: 'خوش آمدید',
    welcomeBackUser: 'خوش آمدید، {{name}}',
    societyWorkspace: 'آپ کا سوسائٹی ورک اسپیس',
    platformSubtitle: 'ویورا پلیٹ فارم · سوسائٹیز اور سافٹ ویئر لائسنسز',
    registerSociety: 'سوسائٹی رجسٹر کریں',
    registerSocietyHint: 'کرایہ دار اور صدر کا لاگ ان بنائیں',
    allSocieties: 'تمام سوسائٹیاں',
    allSocietiesHint: 'فہرست اور حیثیت',
    softwareLicenses: 'سافٹ ویئر لائسنس',
    softwareLicensesHint: 'سوسائٹی منتخب کریں، پھر لائسنس جاری یا جائزہ لیں',
    bankBalance: 'بینک بیلنس',
    outstandingDues: 'واجب الادا رقوم',
    residents: 'رہائشی',
    openRequests: 'کھلی درخواستیں',
    upcomingMeetings: 'آنے والے اجلاس',
    platform: 'پلیٹ فارم',
    societies: 'سوسائٹیاں',
    licenses: 'لائسنسز',
    noBankAccounts: 'ابھی تک کوئی بینک اکاؤنٹ نہیں ہے',
    allDuesCleared: 'تمام واجبات ادا ہو چکے ہیں',
    noOpenComplaints: 'کوئی کھلی شکایت نہیں ہے',
    noMeetingsScheduled: 'کوئی اجلاس طے نہیں ہے',
    overdueAndOpen: '{{overdue}} زائد المیعاد · {{open}} کھلے بلز',
    openBillsCount: '{{count}} کھلے بلز',
    openBillsCountSingle: '1 کھلا بل',
    accountsCountThisMonth: '{{count}} اکاؤنٹس · اس ماہ {{amount}} موصول ہوئے',
    accountsCountThisMonthSingle: '1 اکاؤنٹ · اس ماہ {{amount}} موصول ہوئے',
    residentsAndHouses: '{{residents}} رہائشی · {{houses}} مکانات',
    residentsOnRecord: '{{count}} ریکارڈ میں ہیں',
    housesCount: '{{count}} مکانات',
    pendingReviewOverdue: '{{pending}} زیر جائزہ · {{overdue}} زائد المیعاد',
    pendingReview: '{{count}} زیر جائزہ',
    statManage: 'انتظام',
    statSubscription: 'سبسکرپشن',
    collectionsCashflow: 'وصولیاں اور نقد بہاؤ',
    collected: 'وصول شدہ',
    outstanding: 'بقایا',
    thisMonthCashflow: 'اس ماہ · آمدنی {{credit}} / خرچ {{debit}}',
    cashflow: 'نقد بہاؤ',
    quickActions: 'فوری اقدامات',
    scheduleMeeting: 'اجلاس طے کریں',
    scheduleMeetingHint: 'مالکان اور کیلنڈر کو مطلع کریں',
    postNotice: 'نوٹس جاری کریں',
    postNoticeHint: 'سوسائٹی میں اعلان کریں',
    raiseComplaint: 'شکایت درج کریں',
    raiseComplaintHint: 'سروس کی درخواست درج کریں',
    filePetition: 'درخواست دائر کریں',
    filePetitionHint: 'استعفیٰ یا کارروائی کا مطالبہ',
    viewProfile: 'پروفائل دیکھیں',
    viewProfileHint: 'اکاؤنٹ اور اجازتیں',
    publicPetitions: 'عوامی درخواستیں',
    openPetitions: 'کھلی درخواستیں · تمام اراکین کو دکھائی دیتی ہیں',
    openBoard: 'بورڈ کھولیں',
    noMeetingsDescription: 'آنے والے کمیٹی اجلاس یہاں دکھائی دیں گے۔',
    announcements: 'اعلانات',
    noAnnouncements: 'کوئی اعلان نہیں ہے',
    noAnnouncementsDesc: 'شائع شدہ نوٹس یہاں دکھائی دیں گے۔',
    recentActivity: 'حالیہ سرگرمی',
    noActivity: 'ابھی تک کوئی سرگرمی نہیں ہے',
    noActivityDesc: 'اطلاعات اور اپ ڈیٹس یہاں دکھائی دیں گے۔',
    recentTransactions: 'حالیہ لین دین',
    visitorActivity: 'زائرین کی سرگرمی',
    visitorsComingSoon: 'زائرین ماڈیول جلد آرہا ہے',
    visitorsComingSoonDesc: 'جب زائرین کا ماڈیول فعال ہوگا تو گیٹ لاگز یہاں ظاہر ہوں گے۔',
    openVisitors: 'زائرین کھولیں',
    recentNotices: 'حالیہ نوٹس',
    pendingComplaints: 'زیر التواء شکایات',
    upcomingEvents: 'آنے والی تقریبات',
    maintenanceDue: 'مینٹیننس واجبات',
    visitorsToday: 'آج کے مہمان',
    viewAll: 'تمام دیکھیں',
    societyOverview: 'سوسائٹی کا جائزہ',
    activeNotices: 'فعال نوٹس',
  },
  complaints: {
    title: 'ہیلپ ڈیسک اور شکایات',
    createComplaint: 'شکایت درج کریں',
    category: 'زمرہ',
    priority: 'ترجیح',
    status: 'حیثیت',
    description: 'تفصیل',
    raisedBy: 'درج کنندہ',
    assignedTo: 'تفویض کردہ',
    resolve: 'حل شدہ نشان زد کریں',
    myComplaints: 'میری شکایات',
    allComplaints: 'تمام سوسائٹی شکایات',
  },
  visitors: {
    title: 'مہمانوں کا انتظام',
    logVisitor: 'مہمان کی پیشگی منظوری',
    visitorName: 'مہمان کا نام',
    phone: 'فون نمبر',
    hostUnit: 'فلیٹ / یونٹ',
    purpose: 'دورے کا مقصد',
    vehicleNumber: 'گاڑی کا نمبر',
    checkIn: 'چیک ان',
    checkOut: 'چیک آؤٹ',
    expectedVisitors: 'متوقع مہمان',
    activeVisitors: 'فی الحال اندر موجود',
  },
  finance: {
    title: 'مالیات اور ادائیگیاں',
    dues: 'واجب الادا رقوم',
    payNow: 'ابھی ادائیگی کریں',
    transactions: 'لین دین کی تاریخ',
    invoices: 'مینٹیننس انوائسز',
    receipts: 'ادائیگی کی رسیدیں',
    paymentHistory: 'ادائیگی کی تاریخ',
    maintenanceFee: 'ماہانہ مینٹیننس فیس',
    outstandingBalance: 'کل بقایا',
    paid: 'ادا شدہ',
    unpaid: 'غیر ادا شدہ',
  },
  notices: {
    title: 'سوسائٹی نوٹس بورڈ',
    createNotice: 'نوٹس جاری کریں',
    important: 'اہم نوٹس',
    publishedOn: 'شائع ہونے کی تاریخ',
    readMore: 'مکمل پڑھیں',
    attachments: 'منسلک دستاویزات',
    societyAnnouncements: 'کمیونٹی اعلانات',
  },
  amenities: {
    title: 'سوسائٹی کی سہولیات',
    bookAmenity: 'سہولت بک کریں',
    myBookings: 'میری بکنگز',
    availableSlots: 'دستیاب اوقات',
    rules: 'سہولت کے قواعد اور ہدایات',
  },
  elections: {
    title: 'انتخابات اور ووٹنگ',
    activeElections: 'فعال انتخابات',
    castVote: 'اپنا ووٹ ڈالیں',
    candidates: 'امیدوار',
    results: 'انتخابی نتائج',
  },
  emergency: {
    emergencyAlert: 'ہنگامی الرٹ (EMERGENCY)',
    triggerAlert: 'ایس او ایس الرٹ بھیجیں',
    fire: 'آگ لگنے کی ایمرجنسی',
    medical: 'طبی ایمرجنسی',
    security: 'سیکیورٹی خطرہ',
    panic: 'پینک بٹن',
    sos: 'ایس او ایس براڈکاسٹ',
    activeAlert: 'ہنگامی الرٹ فعال ہے',
  },
  validation: {
    required: 'یہ فیلڈ درکار ہے۔',
    invalidEmail: 'براہ کرم درست ای میل پتہ درج کریں۔',
    invalidMobile: 'براہ کرم درست 10 ہندسوں کا موبائل نمبر درج کریں۔',
    passwordTooShort: 'پاس ورڈ کم از کم 8 حروف پر مشتمل ہونا چاہیے۔',
    positiveNumber: 'براہ کرم مثبت عدد درج کریں۔',
  },
  superAdmin: {
    title: 'پلیٹ فارم ایڈمنسٹریشن',
    dashboard: 'ڈیش بورڈ',
    platformOverview: 'پلیٹ فارم کا جائزہ',
    platformOverviewSubtitle: 'ریئل ٹائم ملٹی ٹیننٹ سوسائٹی کے اعداد و شمار، سبسکرپشن کی حیثیت، اور پلیٹ فارم کی سرگرمیاں',
    totalSocieties: 'کل سوسائٹیاں',
    societiesActiveAndTrial: '{{active}} فعال · {{trial}} ٹرائل پر',
    monthlyRecurring: 'ماہانہ بار بار ہونے والی آمدنی (MRR)',
    annualRecurring: 'سالانہ ARR: {{arr}}',
    activeTrials: 'فعال ٹرائلز',
    expiringInDays: '30 دنوں میں {{count}} ختم ہو رہے ہیں',
    totalPlatformUsers: 'کل پلیٹ فارم صارفین',
    acrossAllManagedSocieties: 'تمام منظم سوسائٹیوں میں',
    upcomingExpirations: 'آنے والی آزمائش اور لائسنس کی میعاد ختم ہونے کا وقت (اگلے 30 دن)',
    upcomingExpirationsSubtitle: 'وہ سوسائٹیاں جنہیں ٹرائل میں توسیع، تجدید یا تبدیلی کی ضرورت ہے',
    noUpcomingExpirations: 'اگلے 30 دنوں میں کسی لائسنس کی میعاد ختم نہیں ہو رہی۔',
    societyName: 'سوسائٹی کا نام',
    plan: 'پلان',
    expiresIn: 'میعاد ختم ہونے کا وقت',
    manage: 'انتظام کریں',
    subscriptionTierShare: 'سبسکرپشن پلان کا حصہ',
    subscriptionTierShareSubtitle: 'پلان کے مطابق فعال سوسائٹیوں کی تقسیم',
    noPlanDistribution: 'پلان کی تقسیم کا کوئی ڈیٹا دستیاب نہیں ہے',
    daysCount: '{{count}} دن',
    expiredToday: 'آج ہی میعاد ختم ہوئی',
    freeTrial: 'مفت ٹرائل',
    analytics: 'پلیٹ فارم کے تجزیات',
    societies: 'تمام سوسائٹیاں',
    societyTypes: 'سوسائٹی کی اقسام',
    trials: 'مفت آزمائش اور آن بورڈنگ',
    subscriptions: 'سبسکرپشنز',
    licenses: 'سافٹ ویئر لائسنس',
    plans: 'سبسکرپشن پلانز',
    invoices: 'بلنگ اور انوائسز',
    pricingOverrides: 'قیمتوں میں تبدیلیاں',
    coupons: 'کوپنز اور چھوٹ',
    promotion: 'ترقی اور تشہیر',
    referrals: 'ملحقہ اور ریفرلز',
    marketing: 'مارکیٹنگ کا عملہ',
    websiteCms: 'ویب سائٹ سی ایم ایس اور برانڈنگ',
    features: 'فیچر فلیگز',
    platformUsers: 'پلیٹ فارم ایڈمنسٹریٹرز',
    systemHealth: 'سسٹم کی حالت',
    auditLogs: 'آڈٹ لاگز',
    settings: 'عالمی ترتیبات',
    dataCleanup: 'ڈیٹا کی صفائی',
    maintenance: 'ڈیٹا بیس کی دیکھ بھال',
  },
  tables: {
    noRecords: 'معیار کے مطابق کوئی ریکارڈ نہیں ملا',
    rowsPerPage: 'سطریں فی صفحہ:',
    pageOf: 'صفحہ {{page}} کل {{totalPages}} میں سے',
    filterResults: 'نتائج فلٹر کریں...',
    showingResults: 'کل {{count}} نتائج دکھائے جا رہے ہیں',
  },
  dialogs: {
    confirmAction: 'کارروائی کی تصدیق کریں',
    confirmDelete: 'حذف کرنے کی تصدیق کریں',
    areYouSure: 'کیا آپ واقعی آگے بڑھنا چاہتے ہیں؟',
    irreversibleNotice: 'یہ عمل واپس نہیں کیا جا سکتا۔',
    discardChanges: 'غیر محفوظ شدہ تبدیلیاں ضائع کریں؟',
  },
  feedback: {
    savedSuccess: 'تفصیلات کامیابی سے محفوظ ہو گئیں',
    updateSuccess: 'کامیابی سے اپ ڈیٹ ہو گیا',
    errorOccurred: 'ایک خرابی پیش آگئی۔ براہ کرم دوبارہ کوشش کریں۔',
    languageChanged: 'زبان اردو میں تبدیل ہو گئی ہے',
    biometricEnabledSuccess: 'بائیو میٹرک تصدیق فعال ہے',
    biometricDisabledSuccess: 'بائیو میٹرک تصدیق غیر فعال ہے',
  },
};
